import { useState } from 'react';
import { MANIFESTS } from './content';
import { Sidebar } from './components/Sidebar';
import { Hero } from './components/Hero';
import { Validator } from './components/Validator';
import { Prereqs } from './components/Prereqs';
import { ConstructMode } from './components/ConstructMode';
import { Split } from './components/Split';
import { Install } from './components/Install';
import { Examples } from './components/Examples';
import { ManifestReference, ActionReference } from './components/Reference';
import { Footer } from './components/Footer';

export function App() {
  // Held here so the examples browser can push a file into the validator.
  const [manifestText, setManifestText] = useState(MANIFESTS[0]?.body ?? '');

  return (
    <div className="layout">
      <Sidebar />
      <main>
        <Hero />
        <Prereqs />
        <Install />
        <Validator text={manifestText} onChange={setManifestText} />
        <ManifestReference />
        <ActionReference />
        <ConstructMode />
        <Split />
        <Examples onLoadIntoValidator={setManifestText} />
        <Footer />
      </main>
    </div>
  );
}
